import { useEffect } from 'react'
import { buildProductDetailsPath } from '@cannect/utils/productUrl'
import { useProductDetails } from './useProductDetails'

export const RedirectPageProduct = () => {
  const { productDetails } = useProductDetails()
  useEffect(() => {
    if (productDetails) {
      const newUrl = buildProductDetailsPath(productDetails.brand?.name, productDetails.name, productDetails.id)
      if (window.location.pathname !== newUrl) {
        window.location.href = newUrl
      }
    }
  }, [])
  return null
}
